import { render, staticRenderFns } from "./ServerGroupDropdown.vue?vue&type=template&id=80c3286c&scoped=true&"
import script from "./ServerGroupDropdown.vue?vue&type=script&lang=js&"
export * from "./ServerGroupDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c3286c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
